import { memo, useState } from 'react'
import { BadgePercent, Info } from 'lucide-react'
import { cn } from '@/lib/utils'
import { PlanDialog } from './PlanDialog'
import { ReadmeDialog } from './ReadmeDialog'

type ModalKey = 'plan' | 'readme' | null

/**
 * Нижняя панель — 2 кнопки в Visual MVP:
 *   Plan      → статус подписки + продление
 *   README    → о продукте, тариф, FAQ, риски
 *
 * Управление портфелем и открытыми позициями — на polymarket.com (указывается
 * в Renewal modal). В PolyStrike-Visual собственного ЛК нет.
 */
export const BottomBar = memo(function BottomBar() {
  const [modal, setModal] = useState<ModalKey>(null)

  const items: Array<{ key: ModalKey; label: string; icon: typeof BadgePercent }> = [
    { key: 'plan', label: 'Plan', icon: BadgePercent },
    { key: 'readme', label: 'Info', icon: Info },
  ]

  return (
    <>
      <nav
        className="sticky bottom-0 z-30 flex shrink-0 justify-around border-t border-[#1f2937] bg-[#0a0a0a]/95 px-1 pt-1.5 backdrop-blur"
        style={{ paddingBottom: 'calc(0.375rem + env(safe-area-inset-bottom))' }}
        aria-label="Нижняя панель"
      >
        {items.map((it) => {
          const Icon = it.icon
          return (
            <button
              key={it.label}
              type="button"
              onClick={() => setModal(it.key)}
              className={cn(
                'flex min-w-0 flex-1 flex-col items-center gap-0.5 rounded-lg px-1 py-1 text-[10px] font-medium transition-colors',
                'text-[#94a3b8] hover:bg-white/5 hover:text-white',
              )}
            >
              <Icon className="h-5 w-5" />
              <span className="truncate">{it.label}</span>
            </button>
          )
        })}
      </nav>

      <PlanDialog open={modal === 'plan'} onClose={() => setModal(null)} />
      <ReadmeDialog open={modal === 'readme'} onClose={() => setModal(null)} />
    </>
  )
})
